import React, { useState } from "react";
import { Search, XLg } from "react-bootstrap-icons";
import FaqAccordion from "./Sub-Components/Faq-Accordion";
import "./styles/accordion-styles.css";
import "./styles/faq-page.css";

const FAQComponent = () => {
  const [query, setQuery] = useState("");

  return (
    <section className="faq-page content-page">
      <div className="faq-hero">
        <div className="faq-hero__inner">
          <h1 className="faq-hero__title">Frequently asked questions</h1>
          <p className="faq-hero__subtitle">
            Answers about requesting housing, booking, your stay and working
            with Oasis.
          </p>
          <label className="faq-search">
            <Search className="faq-search__icon" aria-hidden="true" />
            <input
              type="search"
              className="faq-search__input"
              placeholder="Search questions"
              aria-label="Search questions"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
            />
            {query && (
              <button
                type="button"
                className="faq-search__clear"
                aria-label="Clear search"
                onClick={() => setQuery("")}
              >
                <XLg aria-hidden="true" />
              </button>
            )}
          </label>
        </div>
      </div>
      <FaqAccordion query={query} />
    </section>
  );
};

export default FAQComponent;
